"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToBasketErrors = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Message = require("../message/Message");
var _Modal = require("../modal/Modal");
var styles = _interopRequireWildcard(require("./add-to-basket-errors.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var AddToBasketErrors = exports.AddToBasketErrors = function AddToBasketErrors(_ref) {
  var errors = _ref.errors,
    clearAddToBasketErrors = _ref.clearAddToBasketErrors,
    _ref$showAsWarnings = _ref.showAsWarnings,
    showAsWarnings = _ref$showAsWarnings === void 0 ? false : _ref$showAsWarnings;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
    className: styles['add-to-basket-errors'],
    footer: false,
    isOpen: true,
    onClose: clearAddToBasketErrors,
    title: "Something went wrong",
    children: errors.map(function (_ref2) {
      var message = _ref2.message,
        code = _ref2.code;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Message.Message, {
        title: message,
        type: showAsWarnings ? 'warning' : 'error'
      }, code);
    })
  });
};
AddToBasketErrors.propTypes = {
  errors: _propTypes.default.arrayOf(_propTypes.default.shape({
    message: _propTypes.default.string.isRequired,
    code: _propTypes.default.string.isRequired
  })).isRequired,
  clearAddToBasketErrors: _propTypes.default.func,
  showAsWarnings: _propTypes.default.bool
};